// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"38":"f41485df","488":"10628e37"}[chunkId] + ".chunk.js";
};